export default __webpack_public_path__ + "static/media/Group1633@2x.7ed74946.png";